function useApproved(userApproved = false, approved = false) {
	if (approved) return userApproved;
	return true;
}

export default useApproved;
